import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/store/auth';
import { paths } from '@/routes/paths';
import styles from './styles.module.css';

export function SplashPage(): JSX.Element {
  const navigate = useNavigate();
  const hasToken = useAuthStore((s) => s.hasToken);
  const { t } = useTranslation();

  useEffect(() => {
    const id = setTimeout(() => {
      navigate(hasToken ? paths.home : paths.authLanding, { replace: true });
    }, 1200);
    return () => clearTimeout(id);
  }, [hasToken, navigate]);

  return (
    <div className={styles.wrap}>
      <div className={styles.logo} aria-label={t('app.name')}>
        <svg viewBox="0 0 80 80" width={88} height={88} aria-hidden>
          <defs>
            <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#dcdde2" />
              <stop offset="1" stopColor="#6e7177" />
            </linearGradient>
          </defs>
          <path d="M40 5l30 12v22c0 18-15 30-30 36C25 69 10 57 10 39V17z" fill="url(#g)" />
          <path
            d="M26 40l9 9 19-22"
            stroke="#0e0e10"
            strokeWidth="5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className={styles.brand}>{t('app.name')}</span>
      </div>
    </div>
  );
}
